import React from 'react';
import PropTypes from 'prop-types';
import ShiftForm from './ShiftForm';
import ShiftGamesCard from './ShiftGamesCard';
import './settings.css';

// Раздел «Смена»: настройки смены + управление играми.
export default function SettingsContent({ shift, refetchShifts }) {
    return (
        <>
            <ShiftForm shift={shift} refetchShifts={refetchShifts} />
            <ShiftGamesCard smenaId={shift.id} />
        </>
    );
}

SettingsContent.propTypes = {
    shift: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
    refetchShifts: PropTypes.func.isRequired
};
